import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TextInput } from '../../types'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalImageEvent } from '../gtm-event/image-events'
import { EventService, WindowRef } from '@spartacus/core'
import { ObjectUtils } from '../../../../shared/utils/object-utils'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
  selector: 'mb-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerModalComponent {

  id$ = new BehaviorSubject<string>('')
  text$ = new BehaviorSubject<TextInput | undefined>(undefined)
  buttonText$ = new BehaviorSubject<TextInput | undefined>(undefined)
  url$ = new BehaviorSubject<string>('')

  @Input() set buttonText (buttonText: TextInput | undefined) {
    this.buttonText$.next(buttonText)
  }

  @Input() set url (url: string | undefined) {
    this.url$.next(url ?? '')
  }

  @Input() set id (id: string | undefined) {
    this.id$.next(id ?? '')
  }

  @Input() set text (text: TextInput | undefined) {
    this.text$.next(text)
  }

  state$ = combineLatest([this.id$, this.text$, this.buttonText$, this.url$]).pipe(
    map(([id, text, buttonText, url]) => ({ id, text, buttonText, url })))

  constructor (private modal: NgbActiveModal,
               protected winRef: WindowRef,
               private events: EventService) {
  }

  close () {
    const eventLabel = ObjectUtils.getInnerText(this.buttonText?.value ?? '')
    this.events.dispatch(new ModalImageEvent('Visuals', eventLabel, false))
    this.modal.close()
    this.winRef.sessionStorage?.setItem(this.url ?? '', 'true')
    this.winRef.sessionStorage?.setItem('disclaimer-' + (this.id ?? ''), 'true')
  }
}
